// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"index-module--menuItem--llG71","menuLinkActive":"index-module--menuLinkActive--1kltr","menuLink":"index-module--menuLink--2hLjj"};